import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    useLocation,
    useNavigate
} from "react-router-dom";

import NavBar from "../components/Navigation/NavBar";

import CustomIcon from "../components/CustomIcon";
import { spinner } from "../redux/slices/spinnerSlice";
import { decodeBase64Payload, getConfig, getConstant, getSubscriptionStatusLabel, handleErrorResponse, handleHeader, isMobile } from "../services/functions";
import axios from "axios";
import { BASE_URL, SUBSCRIPTION_DETAILS_PATH } from "../utility/path";
import { getPaymentRequestStatus } from "../redux/slices/paymentSlice";
import MainContainer from "../components/MainContainer";
import { getProfileAction } from "../redux/slices/profilesSlice";
import { showAlert } from "../redux/slices/alertSlice";
import "../Subscription.css";
import BottomNav from "../components/Navigation/BottomNav";

const Subscription = ({ }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const authData = useSelector(state => state?.auth?.data);

    const [plan, setPlan] = useState(1);
    const [transactions, setTransactions] = useState([]);
    const [disableButton, setDisableButton] = useState(false);
    const [cssColor, setCssColor] = useState('');
    const [cssColorForTab, setCssColorForTab] = useState('btn-outline-success');

    const redirectUrl = window.location.origin;
    const [amount] = useState(99);
    const [discountForPlan2] = useState(10);
    const [discountForPlan3] = useState(20);

    const ALLOW_NEW_TRANSACTIONS = false;

    const PLANS = [
        { id: 1, label: "Starter", months: 12, discount: 0 },
        { id: 2, label: "Medium term", months: 24, discount: 10 },
        { id: 3, label: "Long term", months: 36, discount: 20 },
    ];

    const getAmount = (amount, discount) =>
        Math.round(amount * (discount === 0 ? 1 : (PLANS.find(p => p.discount === discount)?.months / 12)) * (1 - discount / 100));

    const FEATURES = [
        { key: "active", text: (months) => `${months}-month plan — keep your account active.` },
        { key: "nearby", text: () => "Customers near you can find and connect with you directly." },
        { key: "earnings", text: () => "Keep all your earnings — no middlemen or hidden charges." },
        { key: "search", text: () => "Increased probability of appearing in search results." },
        { key: "placement", text: () => "Prioritized placement of your account in search." },
        { key: "support", text: () => "Faster response to any support queries." },
        { key: "recommend", text: () => "Personalized recommendations to maximize your subscription." },
    ];
    

    useEffect(() => {
        handleHeader({...getConstant("SUBSCRIPTION")},dispatch);
        
        const txnId = searchParams && searchParams.get("txnId");
        const plan = searchParams && searchParams.get("plan");

        if(txnId){
            dispatch(getPaymentRequestStatus({ txnId, id: authData?.id, type: "transaction",plan }));
            navigate(SUBSCRIPTION_DETAILS_PATH);
        }else{
            getTransactions();
            dispatch(getProfileAction(authData));
        }

        return () => { handleHeader({...getConstant("HOME")},dispatch); }
    }, []);

    useEffect(() => {
        return () => { }
    }, [plan, cssColor, disableButton]);

    const checkTransacitonStatus = (data) => {
        if (!data) {
            return false;
        }
        const hasPendingTransactions = data.some((r) => r.subscriptionStatus === 2 || r.subscriptionStatus === 0 || r?.state === 'PENDING'); // pending or inactive
        const hasActiveSubscriptions = data.some((r) => r.subscriptionStatus === 1); // active

        
        if (hasPendingTransactions || hasActiveSubscriptions) {
            const firstPendingTransaction = data.find((r) => r.subscriptionStatus === 2 || r.subscriptionStatus === 0 || r.state === 'PENDING');  // not active
            const firstActiveSubscription = data.find((r) => r.subscriptionStatus === 1);

            if (firstActiveSubscription) {
                setPlan(firstActiveSubscription.plan);
                setCssColor('sub-txn-item__status--success');
            } else if (firstPendingTransaction?.subscriptionStatus === 2 || firstPendingTransaction?.subscriptionStatus === 0) {
                setPlan(firstPendingTransaction.plan);
                setCssColor('sub-txn-item__status--warning');
                //setCssColorForTab('btn-outline-warning')
            }
            setDisableButton((state) => { return !ALLOW_NEW_TRANSACTIONS });
            return true;
        }

        return false;
    }
    const onExit = async () => {
        console.log('onExit');
        dispatch(getProfileAction(authData));
    }

    const onSuccess = async () => {
        console.log('onSuccess');
        dispatch(getProfileAction(authData));
    }

    const getStarted = async (event) => {
        //return;
        event.preventDefault();
        
        if(ALLOW_NEW_TRANSACTIONS){

        }else if (!authData?.id || checkTransacitonStatus(transactions)) {
            return;
        }

        try {
            dispatch(spinner(true));
            const config = getConfig();
            let formData = new FormData();
            formData.append("user", authData?.id);
            formData.append("plan", plan);
            formData.append("redirect_url", redirectUrl);
            formData.append("ismobile", isMobile());

            const res = await axios.post(`${BASE_URL}/api/payments/createPayment`, formData, config);
            //console.log(res);
            dispatch(spinner(false));
            if(!isMobile()){ //web call
                window.location.href = res?.data?.data?.instrumentResponse?.redirectInfo?.url;
            }else if (isMobile()) { // mobile call
                if(!res?.data?.bp || !res?.data?.cs || !res?.data?.aepbp || !res?.data?.mibp) {
                    dispatch(showAlert({ message: "Invalid Request, Please try login from website!", success: false }))
                    return;
                }

                let paymentOptions = {
                    bp: res?.data?.bp,
                    cs: res?.data?.cs,
                    aepbp: decodeBase64Payload(res?.data?.aepbp),
                    mibp: decodeBase64Payload(res?.data?.mibp),
                    menv: decodeBase64Payload(res?.data?.menv)
                };
    
                window.plugins.phonepe.startPayment(
                    function(response) {
                    console.log("Payment success:", response);
                        //console.log("Payment res:", res?.data?.data?.merchantTransactionId);
                        // Verify payment with your backend
                        dispatch(getPaymentRequestStatus({ txnId: res?.data?.data?.merchantTransactionId, 
                        id: authData?.id, 
                        type: "enquiry",
                        plan: res?.data?.plan,
                        state:res?.data?.state,
                        ptid:res?.data?.ptid}));
                        navigate(SUBSCRIPTION_DETAILS_PATH);
                    },
                    function(error) {
                        //console.error("Payment error:", error);
                         dispatch(getPaymentRequestStatus({ txnId: res?.data?.data?.merchantTransactionId, 
                        id: authData?.id, 
                        type: "enquiry",
                        plan: res?.data?.plan,
                        state:res?.data?.state,
                        ptid:res?.data?.ptid}));
                        navigate(SUBSCRIPTION_DETAILS_PATH);
                    },
                    paymentOptions
                );
                return;

                const browser = window.cordova.InAppBrowser.open(
                    res?.data?.data?.instrumentResponse?.redirectInfo?.url,'_blank',
                    'location=yes,clearcache=yes,toolbar=no');

                browser.addEventListener('loadstart', (event) => { // Handle browser events
                    if (event.url.startsWith(redirectUrl)) {
                        onSuccess();
                        browser.close(); 
                        browser = null;
                    }
                });

                browser.addEventListener('loaderror', (error) => {
                    console.log('com.gaufi,Payment failed: ' + error.message);
                    browser.close(); 
                    browser = null;
                });

                browser.addEventListener('exit', () => {
                    onExit();
                    browser?.close(); 
                    browser = null;
                });
            }else {
                console.log('platform not identified');
            }
        } catch (error) {
            console.log(error?.message)
            dispatch(spinner(false));
            handleErrorResponse(error, dispatch);
        }
    }

    const getTransactions = useCallback(async () => {
        if (!authData?.id) {
            return;
        };

        try {
            const config = getConfig();
            let formData = new FormData();
            formData.append("user", authData?.id);
            const res = await axios.get(`${BASE_URL}/api/payments/getTransactions`, { ...config, params: { "user": authData?.id } });
            setTransactions(res.data);
            checkTransacitonStatus(res.data);
            await refreshStatus(res.data);

        } catch (error) {
            console.log(error?.message);
            const errorResponse = handleErrorResponse(error, dispatch);
        }
    }, [authData, dispatch]);


    const refreshStatus = async (data) => {
        
        try {
            await Promise.all(data.map(async (element) => {
                if(element?.state === 'PENDING'){
                    await dispatch(getPaymentRequestStatus({ 
                        txnId: element?.paymentRequestId, 
                        id: authData?.id, 
                        type: "enquiry",
                        plan: element?.plan,
                        state:element?.state,
                        ptid:element?.id
                    }));
                }
            }));
        } catch (error) {
            console.log(error?.message);
        }
    }    

    const PlanCard = ({ planData, amount, cssColor, disableButton, onPay }) => {
        //console.log('disableButton',disableButton,cssColor)
        const price = Math.round(
            amount * (planData.months / 12) * (1 - planData.discount / 100)
        );

        return (
            <div className="sub-card">

                {/* Header */}
                <div className={`sub-card__header ${disableButton ? cssColor : ""}`}>
                    <div>
                        <p className="sub-card__name">{planData.label} plan</p>
                        <p className="sub-card__duration">{planData.months} months</p>
                    </div>
                    <div style={{ textAlign: "right" }}>
                        <p className="sub-card__price">
                            <CustomIcon type="currency" />{price}
                        </p>
                        {planData.discount > 0 && (
                            <span className="sub-card__badge">
                                Save {planData.discount}%
                            </span>
                        )}
                        {planData.discount === 0 && (
                            <span className="sub-card__badge">Best value</span>
                        )}
                    </div>
                </div>

                {/* Features */}
                <ul className="sub-features">
                    {FEATURES.map((f) => (
                        <li key={f.key} className="sub-feature">
                            <div className="sub-feature__icon">
                                <i className="fa fa-check" />
                            </div>
                            <p className="sub-feature__text">{f.text(planData.months)}</p>
                        </li>
                    ))}
                </ul>

                {/* Pay button */}
                {!disableButton && (
                    <div className="sub-card__footer">
                        <button className="sub-pay-btn" onClick={onPay}>
                            Pay <CustomIcon type="currency" />{price} — Get Started
                        </button>
                        <p className="sub-trust">
                            <i className="fa fa-lock" /> Secure payment · No hidden charges
                        </p>
                    </div>
                )}

            </div>
        );
    };

const renderForm = () => {
  const visiblePlans = PLANS.filter(p =>
    !disableButton || p.id === plan
  );

  return (
    <>
      {/* Tabs */}
      {!disableButton && (
        <div className="sub-tabs">
          {PLANS.map((p) => (
            <button
              key={p.id}
              className={`sub-tab ${plan === p.id ? "active" : ""}`}
              onClick={() => setPlan(p.id)}
            >
              {p.label}
            </button>
          ))}
        </div>
      )}

      {/* Active plan card */}
      {visiblePlans
        .filter(p => p.id === plan)
        .map(p => (
          <PlanCard
            key={p.id}
            planData={p}
            amount={amount}
            cssColor={cssColor}
            disableButton={disableButton}
            onPay={getStarted}
          />
        ))
      }
    </>
  );
};

    // const renderForm = () => {
    //     return (
    //         <>
    //             <div className="btn-group" role="group" aria-label="Basic radio toggle button group">

    //                 {plan !== 1 && disableButton ? '' : (<><input type="radio" className="btn-check" name="btnradio" id="btnradio1" autoComplete="off" onChange={() => setPlan(1)} checked={plan === 1} disabled={plan !== 1 && disableButton} />
    //                 <label className={`btn ${plan === 1 && disableButton ? cssColorForTab : 'btn-outline-primary'}`} htmlFor="btnradio1">Starter plan</label></>)}

    //                 {plan !== 2 && disableButton ? '' : (<><input type="radio" className="btn-check" name="btnradio" id="btnradio2" autoComplete="off" onChange={() => setPlan(2)} checked={plan === 2} disabled={plan !== 2 && disableButton} />
    //                 <label className={`btn ${plan === 2 && disableButton ? cssColorForTab : 'btn-outline-primary'}`} htmlFor="btnradio2">Medium term plan</label></>)}

    //                 {plan !== 3 && disableButton ? '' : (<><input type="radio" className="btn-check" name="btnradio" id="btnradio3" autoComplete="off" onChange={() => setPlan(3)} checked={plan === 3} disabled={plan !== 3 && disableButton} />
    //                 <label className={`btn ${plan === 3 && disableButton ? cssColorForTab : 'btn-outline-primary'}`} htmlFor="btnradio3">Long term plan</label></>)}
                    
    //             </div>

    //             {plan === 1 ? <div className="mt-3">
    //                 <div className="card">
    //                     <div className={`card-header ${disableButton ? `${cssColor}` : ''}`}>Starter plan</div>
    //                     <div className="card-body">
    //                         <h1 className="card-title"><CustomIcon type="currency" />{amount  * 1 }</h1>
    //                         <ul style={{listStyleType:'disc'}} className="p-2">
    //                             <li><b>12-months plan, </b>keep your account <b className="text-success">active</b>.</li>
    //                             <li><b className="text-success">Customers near you</b> can easily find your profile on <b>Gaufi</b> and <b className="text-success">connect with you directly</b>.</li>
    //                             <li>You keep all your earnings. We don't take a cut, and there are <b className="text-success">no middlemen</b> or <b className="text-success">hidden charges</b>.</li>
    //                             <li><b className="text-success">Increased</b> probability of your account appearing in the <b className="text-success">search results</b>.</li>
    //                             <li><b className="text-success">Prioritized placement</b> of your account in the search.</li>
    //                             <li>Faster response to any <b className="text-success">support queries</b>.</li>
    //                             <li><b className="text-success">Personalized recommendations</b> from our team to maximize the benefits of your subscription.</li>
    //                         </ul>
    //                     </div>
    //                     {!disableButton ? <div className="card-footer"><button type="button" className="btn btn-lg btn-block btn-outline-primary" onClick={getStarted}>Pay</button></div> : ''}
    //                 </div>
    //             </div> : null}
    //             {plan === 2 ? <div className="mt-3">
    //                 <div className="card">
    //                     <div className={`card-header ${disableButton ? `${cssColor}` : ''}`}>Medium term plan</div>
    //                     <div className="card-body">
    //                         <h1 className="card-title"><CustomIcon type="currency" />{Math.round(amount * 2 - amount * 2 * (discountForPlan2 / 100))}</h1>
    //                         <ul style={{listStyleType:'disc'}} className="p-2">
    //                             <li><b>24-months plan, </b>keep your account <b className="text-success">active</b>.</li>
    //                             <li>Saving <b className="bg-success text-white">{discountForPlan2}%</b> of subscription amount in a year.</li>
    //                             <li><b className="text-success">Customers near you</b> can easily find your profile on <b>Gaufi</b> and <b className="text-success">connect with you directly</b>.</li>
    //                             <li>You keep all your earnings. We don't take a cut, and there are <b className="text-success">no middlemen</b> or <b className="text-success">hidden charges</b>.</li>
    //                             <li><b className="text-success">Increased</b> probability of your account appearing in the <b className="text-success">search results</b>.</li>
    //                             <li><b className="text-success">Prioritized placement</b> of your account in the search.</li>
    //                             <li>Faster response to any <b className="text-success">support queries</b>.</li>
    //                             <li><b className="text-success">Personalized recommendations</b> from our team to maximize the benefits of your subscription.</li>
    //                         </ul>
    //                     </div>
    //                     {!disableButton ? <div className="card-footer"><button type="button" className="btn btn-lg btn-block btn-outline-primary" onClick={getStarted}>Pay</button></div> : ''}
    //                 </div>
    //             </div> : null}
    //             {plan === 3 ? <div className="mt-3">
    //                 <div className="card">
    //                     <div className={`card-header ${disableButton ? `${cssColor}` : ''}`}>Long term plan</div>
    //                     <div className="card-body">
    //                         <h1 className="card-title"><CustomIcon type="currency" />  {Math.round(amount * 3 - amount * 3 * (discountForPlan3 / 100))}</h1>
    //                         <ul style={{listStyleType:'disc'}} className="p-2">
    //                             <li><b>36-months plan, </b>keep your account <b className="text-success">active</b>.</li>
    //                             <li>Saving <b className="bg-success text-white">{discountForPlan3}%</b> of subscription amount in a year.</li>
    //                             <li><b className="text-success">Customers near you</b> can easily find your profile on <b>Gaufi</b> and <b className="text-success">connect with you directly</b>.</li>
    //                             <li>You keep all your earnings. We don't take a cut, and there are <b className="text-success">no middlemen</b> or <b className="text-success">hidden charges</b>.</li>
    //                             <li><b className="text-success">Increased</b> probability of your account appearing in the <b className="text-success">search results</b>.</li>
    //                             <li><b className="text-success">Prioritized placement</b> of your account in the search.</li>
    //                             <li>Faster response to any <b className="text-success">support queries</b>.</li>
    //                             <li><b className="text-success">Personalized recommendations</b> from our team to maximize the benefits of your subscription.</li>
    //                         </ul>
    //                     </div>
    //                     {!disableButton ? <div className="card-footer"><button type="button" className="btn btn-lg btn-block btn-outline-primary" onClick={getStarted}>Pay</button></div> : ''}
    //                 </div>
    //             </div> : null}
    //         </>
    //     );
    // }

    return (
        <>
            <NavBar />
            <MainContainer>
                {renderForm()}

                <div className="sub-txn-section">
                    <p className="sub-txn-title">Transaction history</p>

                    {transactions.length === 0 ? (
                        <div className="sub-txn-empty">
                            <i className="fa fa-credit-card sub-txn-empty__icon" />
                            <p>No transactions yet</p>
                        </div>
                    ) : (
                        <div className="sub-txn-list">
                            {transactions.map((r) => {
                                const statusColor =
                                    r.subscriptionStatus === 1 ? "success" :
                                        r.subscriptionStatus === 2 || r.subscriptionStatus === 0 ? "warning" :
                                            r.subscriptionStatus === 3 ? "error" : "default";

                                return (
                                    <div key={r.id} className="sub-txn-item">
                                        <div className="sub-txn-item__header">
                                            <div>
                                                <p className="sub-txn-item__purpose">{r.purpose}</p>
                                                {r?.updatedAt && (
                                                    <p className="sub-txn-item__date">
                                                        <i className="fa fa-clock-o" />{" "}
                                                        {new Date(r.updatedAt).toLocaleString()}
                                                    </p>
                                                )}
                                            </div>
                                            <span className={`sub-txn-item__status sub-txn-item__status--${statusColor}`}>
                                                {getSubscriptionStatusLabel(r.subscriptionStatus)}
                                            </span>
                                        </div>

                                        <div className="sub-txn-item__body">
                                            {r?.transactionId && (
                                                <div className="sub-txn-item__row">
                                                    <span className="sub-txn-item__label">Transaction ID</span>
                                                    <span className="sub-txn-item__value">{r.transactionId}</span>
                                                </div>
                                            )}
                                            {r?.subscriptionEndDate && (
                                                <div className="sub-txn-item__row">
                                                    <span className="sub-txn-item__label">Expires</span>
                                                    <span className="sub-txn-item__value">
                                                        {new Date(r.subscriptionEndDate).toLocaleDateString()}
                                                    </span>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    )}
                </div>

                {/* <div id="accordion" className="mt-3 mb-3">
                    <h5>Transactions history</h5>
                    {
                        transactions.map((r, index) => (
                            <div className="card" key={r.id}>
                                <div className="card-header" id={`headingOne_${r.id}`}>
                                    <h5 className="mb-0">
                                        <button className="btn link-primary collapsed" data-toggle="collapse" data-target={`#collapseOne_${r.id}`} aria-expanded="false" aria-controls={r.id}>
                                            {r.purpose} {"(Status: "+getSubscriptionStatusLabel(r.subscriptionStatus)+")"}
                                        </button>
                                    </h5>
                                </div>

                                <div id={`collapseOne_${r.id}`} className="collapse" aria-labelledby={`headingOne_${r.id}`} data-parent="#accordion">
                                    <div className="card-body">
                                        <ul className="p-1">
                                            {r?.transactionId ? (<li><strong>Transaction ID: </strong>{r.transactionId}</li>) : ''}
                                            <li>
                                                {r?.updatedAt && <div><strong>Transaction date: </strong>{new Date(r.updatedAt).toLocaleString()} </div>}
                                            </li>
                                            <li>
                                                {r?.subscriptionEndDate && <div><strong>Subscription end date: </strong>{new Date(r.subscriptionEndDate).toLocaleDateString()}</div>}
                                            </li>
                                            <li>
                                                {r.subscriptionStatus && <div><strong>Status: </strong>{getSubscriptionStatusLabel(r.subscriptionStatus)}</div>}
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        ))
                    }
                    {!transactions || !transactions?.length && <div>No transactions</div>}
                </div> */}
            </MainContainer>
            <BottomNav/>
        </>
    );
}

export default Subscription;